<template>
  <div>
    <div>
      <label><input type="checkbox" v-model="intercept"/>Replace token in api calls</label>
    </div>
    <div class="intercept-menu" v-if="intercept">
      <h3>Available tokens:</h3>
      <div v-for="token in tokens">
        <label>
          <input type="radio" name="debug-token" :value="token.value" v-model="activeToken"/>
          <span>{{ token.name }}</span><span style="color: #bbb"> ({{ token.value.length > 30 ? token.value.substring(0,30)+"..." : token.value }})</span>
        </label>
      </div>
      <button @click="addToken">Add token</button>

      <h3>Request filters:</h3>
      <button @click="addIgnoredPath">Add ignored path</button>
      <div v-for="(path,index) in ignoredPaths">Ignore path: {{ path }} <button @click="removeIgnoredPathAt(index)">Remove</button></div>
      <div>
        <label>
          Request path regex
          <input type="text" v-model="requestPathRegex"/>
        </label>
        <label>
          Invert regex match
          <input type="checkbox" v-model="invertRequestPathRegex"/>
        </label>
      </div>
    </div>
  </div>
</template>

<script>

import apiCall from '../../../utils/api';
import axios from 'axios';

export default {
  name: "ApiCallInterceptor",

  components: {
  },

  data: function () {
    return {
      activeToken: null,
      tokens: [],
      intercept: false,
      ignoredPaths: [],
      requestPathRegex: "",
      invertRequestPathRegex: false,
      interceptor: null,
    }
  },

  methods: {
    addToken: function() {
      let value = window.prompt("Token value");

      if(!value)
        return;

      this.pushToken(value,true);
    },

    addIgnoredPath: function() {
      let path = window.prompt("Path to ignore");

      this.ignoredPaths.push(path);

      this.storeIgnoredPaths();
    },

    removeIgnoredPathAt: function(index) {
      this.ignoredPaths.splice(index,1);
      this.storeIgnoredPaths();
    },

    storeIgnoredPaths: function() {
      sessionStorage.setItem("debug-menu-api-call-interceptor-ignored-paths",JSON.stringify(this.ignoredPaths));
    },

    loadIgnoredPaths: function() {
      let storedPaths = sessionStorage.getItem("debug-menu-api-call-interceptor-ignored-paths");

      try
      {
        storedPaths = JSON.parse(storedPaths);
      }
      catch(error)
      {
        console.log("Failed to parse stored ignored paths",error);
        return;
      }

      if(!storedPaths)
        return;

      for(let path of storedPaths)
        this.ignoredPaths.push(path);
    },

    getStoredTokens: function() {
      let stored = sessionStorage.getItem("debug-menu-api-call-interceptor-tokens");

      if(!stored)
        return [];

      try
      {
        return JSON.parse(stored);
      }
      catch(error)
      {
        console.warn("Failed to parse stored interceptors",stored);
        return [];
      }
    },

    setStoredTokens: function(contents) {
      sessionStorage.setItem("debug-menu-api-call-interceptor-tokens",JSON.stringify(contents));
    },

    pushToken: function(tokenValue,store) {
      let token = {
        name: "Loading...",
        value: tokenValue,
      };

      this.tokens.push(token);

      if(store) {
        let stored = this.getStoredTokens();
        stored.push(token);
        this.setStoredTokens(stored);
      }

      axios.create({
        baseURL: window.FlowWebsiteGlobalConfig.basePaths.flowController,
      }).get('v1/users/data',{
        headers: {
          "Authorization": tokenValue
        }})
      .then((response) => {
        let fullName = response.data.fullName;
        let organization = response.data.organization.name;
        let userRole = response.data.organizationUserRole;
        this.setTokenName(tokenValue,`${fullName} (${organization} ${userRole})`);
      })
      .catch((error) => {
        console.log("Failed to resolve token '",tokenValue,"'. See network log.");
        this.setTokenName(tokenValue,"Invalid token");
      });
    },

    setTokenName: function(tokenValue,tokenName)
    {
      for(let token of this.tokens) {
        if(token.value == tokenValue)
          token.name = tokenName;
      }
    },
  },

  mounted: function() {
    this.activeToken = localStorage.getItem("flow-user-token");
    this.pushToken(this.activeToken,false);

    for(let token of this.getStoredTokens())
    {
      this.pushToken(token.value,false);
    }

    this.loadIgnoredPaths();

    this.interceptor = apiCall.interceptors.request.use((config) => {
      // If we are intercepting, replace the Authorization value with the token picked
      // with the radio buttons.

      let matches = false;

      if(!this.requestPathRegex)
        matches = true;
      else if(!this.invertRequestPathRegex && new RegExp(this.requestPathRegex).test(config.url))
        matches = true;
      else if(this.invertRequestPathRegex && !(new RegExp(this.requestPathRegex).test(config.url)))
        matches = true;

      for(let path of this.ignoredPaths) {
        if(config.url == path) // Exact match
          matches = false;
      }

      if(this.intercept) {
        if(matches) {
          console.log("Replacing 'Authorization' value in ApiCallInterceptor for ",config.url);
          config.headers["Authorization"] = this.activeToken;
        } else {
          console.log("Not replacing 'Authorization' value in ApiCallInterceptor for ",config.url);
        }
      }

      return config;
    }, function (error) {
      // No error handling needed here for now
      return Promise.reject(error);
    });
  },

  unmounted: function() {
    apiCall.interceptors.request.eject(this.interceptor);
  },
}


</script>

<style scoped>
  .intercept-menu {
    padding: 10px;
    border: 1px solid grey;
  }
</style>
